module.exports = __webpack_public_path__ + "static/media/shapes.f8ca36c2.svg";